import { green, red, yellow } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';
import LegendIcon from '@material-ui/icons/FiberManualRecord';
import React, { FC } from 'react';
import AppAlert from '../../ui/alert/AppAlert';
import { AppText } from '../../ui/text';

const useStyles = makeStyles(
  (theme) => ({
    legendElement: {
      display: 'inline-flex',
      flexWrap: 'wrap',
      marginRight: theme.spacing(2),
    },
  }),
  { name: 'ChatbotImportListLegend' },
);

const ChatbotImportListLegend: FC = () => {
  const classes = useStyles();
  return (
    <AppAlert title="Legenda" severity="info" style={{ backgroundColor: 'white' }}>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: yellow[600] }} />
        In attesa di importazione
      </AppText>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: green[300] }} />
        Importato con successo
      </AppText>
      <AppText className={classes.legendElement}>
        <LegendIcon style={{ color: red[300] }} />
        Errore di importazione
      </AppText>
    </AppAlert>
  );
};

export default ChatbotImportListLegend;
